import React from 'react'
import { NavLink } from 'react-router-dom'
import Donate from './Donate'

function NavbarItem({ item }) {
  return (
    <NavLink
      exact={true}
      activeStyle={{
        borderBottom: "1px solid #4e4e4e",
      }}
      style={{
        color: '#243665',
        fontWeight: 600,
        letterSpacing: 1.12,
        marginLeft: '1rem',
        borderBottom: '1px solid transparent'
      }}
      to={item.to} className="NavItem" activeClassName='is-active'>
      <span>
        {item.name}
      </span>
    </NavLink>
  )
}

export default function Navbar({ style }) {

  const navItems = [
    { name: 'My Cats', to: '/' },
  ]

  return (
    <div style={{ display: 'flex', alignItems: 'center', color: '#f3f3f3', backgroundColor: '#4A235A', ...style }}>
      <div>
        <h1 className="title" style={{ fontWeight: 900, marginBottom: 5, color: '#88ee88', fontFamily: `'logotype', courier, mono space;` }}>MoonCats Data</h1>
        <div style={{ fontWeight: 600 }}>Unofficial name and trait data for https://mooncatrescue.com/</div>
        <Donate />
      </div>
      <nav className="navbar Navbar" role="navigation" aria-label="main navigation" style={{ display: 'flex', fontSize: '1.15rem', marginLeft: 'auto' }}>
        <ul style={{ display: 'flex', margin: 5, alignItems: 'center', marginLeft: 'auto' }}>
          {navItems.map(item => <NavbarItem key={item.to} item={item} style={{ backgroundColor: 'transparent' }} />)}
        </ul>
      </nav>
    </div>
  )
}